import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './notification.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// CONNECT TO GLOBAL STATE
import { connect } from 'react-redux';
// GET GENERIC METHOD LIBRARY
import * as moduleActions from '../moduleActions';

class Notification extends Component {
    constructor(props) {
      super(props);
      this.state = {
        allowFilterType:true,
        show:true,
        inactiveType : [],
        moduleName:"NOTIFICATION",
      };

    }
    
    // INNER METHOD
    // ---- ON COMPONENT CREATION
    componentDidMount = () =>{
      // CREATE MODULE DATA IN STATE MODULE OBJECT
      this.props.registerModule(this.state.moduleName);
      document.addEventListener('click', this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }
    
    handleClickOutside = (event) => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
         // this.props.toggleExpand("");
        }
    }

    // ---- TOGGLE TYPE FILTER
    toggleInactiveType = (type) =>{
      var inactiveTypeList = this.state.inactiveType;
      if(inactiveTypeList.includes(type)){
        this.setState({inactiveType:inactiveTypeList.filter(item=>item !== type)});
      }else{
        inactiveTypeList.push(type);
        this.setState({inactiveType:inactiveTypeList});
      }
     
    }

    // GENERIC MODULE METHOD
    updateNotification= (key) =>{
      var notificationHistory = this.props.modulesData[this.state.moduleName];
      notificationHistory[key].isRead = true;

      this.props.updateNotification(this.state.moduleName,notificationHistory);
    }

    removeNotification= (key) =>{
      var notificationHistory = this.props.modulesData[this.state.moduleName];
      notificationHistory.splice(key, 1);
      this.props.updateNotification(this.state.moduleName,notificationHistory);
    }
    resetVisibility = () =>{
      //this.setState({show:true});
    }

    

    buildNotificationtypes = () =>{
      var typeElements = null;
      if(Object.keys(this.props.modulesData).includes(this.state.moduleName)){
        var typeList = this.props.modulesData[this.state.moduleName].map(item=>item.type);
        var inactiveType = this.state.inactiveType;
        typeList = [...new Set(typeList)];
        typeElements = typeList.map((item,key)=>{
         return <div key={key} onClick={this.toggleInactiveType.bind(this,item)} className={inactiveType.filter(inactiveItem => inactiveItem === item).length>0?"typeItem inactive":"typeItem"}><FontAwesomeIcon  icon={item}/></div>
        });
      }
        
        
        return <div className="typeBlock">{typeElements}</div>;
    }

    buildNotificationBlock = (notificationHistory) => {
      var inactiveType = this.state.inactiveType;
      var contentList = null;
      if(notificationHistory.length>0){
        contentList = notificationHistory.filter(item=> !inactiveType.includes(item.type)).map((item,key)=>{
          
          return <div key={key} onMouseLeave={this.updateNotification.bind(this,key)}  className={item.isRead ? "notificationItem" : "notificationItem unread"}>
            <div className="notificationItemHeader">
              <FontAwesomeIcon  icon={item.type}/>
              <h1>{item.title} <span>{item.date}</span></h1>
              <FontAwesomeIcon onClick={this.removeNotification.bind(this,key)}  icon="times"/>
              </div>
            <div className="notificationContent">
              {item.description}
            </div>
          </div>
        });
      }else{
        contentList = <div className="placeHolder-list">
                          <span>No notification to display</span>
                      </div>
        ;
      }
      

      return(
        <div className="notificationBlock">
          {contentList}
        </div>
      )
    }
  
  
    render() {
      // INITIATE VAR
      var notificationHistory = null;
      var notificationBlock = null;
      var notificationTypes = null;
      var alert = null;

      // IF MODULESDATA IS REGISTERED
      if(Object.keys(this.props.modulesData).includes(this.state.moduleName)){ 
        notificationHistory = this.props.modulesData[this.state.moduleName];  
        notificationBlock = this.buildNotificationBlock(notificationHistory);
        notificationTypes = this.state.allowFilterType? this.buildNotificationtypes(): null;
        alert = notificationHistory.filter(item =>!item.isRead).length > 0 ? <div className="alert"></div> : null; 
      }
      

      return (
        <div  onClick={this.resetVisibility.bind()} className={this.props.extendedModule === this.state.moduleName?"header-column extended":"header-column"}  >
          <FontAwesomeIcon icon="bell" onClick={this.props.toggleExpand.bind(this,this.state.moduleName)}/> 
          {alert}
          <div className="extendBlocks" /*onMouseOut={this.hideBlocks}*/>
          <div className="extendBlocksHeader"><div className="headerTitle">Notification pannel</div>{notificationTypes}</div>
            {notificationBlock}
          </div>
        </div>
      );
    }
  }
  
  // GET DATA FROM GLOBAL STATE
  const mapStateToProps = (state) => {    
    return {  
      modulesData: state.appReducer.modulesData,
      extendedModule: state.appReducer.extendedModule,
    } 
  }

  // GET METHOD FROM MOUDLEACTION OR REPOSITORYACTION if needed
  const mapDispatchToProps = (dispatch) => {
    return {
      toggleExpand: (type) => dispatch(moduleActions.toggleExpand(type)),
      registerModule: (type) =>dispatch(moduleActions.registerModule(type)),
      updateNotification: (type,data) => dispatch(moduleActions.updateModuleData(type,data)),
      addNotification: (type,data) => dispatch(moduleActions.addModuleData(type,data)),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(Notification);
